import {useGetAutoDeliveryDetailsDcx} from '@/api/consumerApi';
import {AUTO_DELIVERY_INFO_BOX_SOURCES} from '@/types/content';
import {AutoDeliveryDcxActiveInfoBox} from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxActiveInfoBox';
import AutoDeliveryDcxStatusBadge from '@/views/AutoDeliveryDcx/AutoDeliveryDcxStatusBadge';

import AutoDeliveryDcxOrderFrequency from './components/AutoDeliveryDcxOrderFrequency';
import AutoDeliveryDcxWidgetContainer from './components/AutoDeliveryDcxWidgetContainer';
import AutoDeliveryDcxWidgetHeader from './components/AutoDeliveryDcxWidgetHeader';

type AutoDeliveryDcxStatusActiveNoOrderProps = {
    className?: string;
};

const AutoDeliveryDcxStatusActiveNoOrder = ({className}: AutoDeliveryDcxStatusActiveNoOrderProps) => {
    const {data} = useGetAutoDeliveryDetailsDcx();

    const {minDeliveryDaysCount, maxDeliveryDaysCount, frequency} = data?.autoDelivery || {};

    return (
        <AutoDeliveryDcxWidgetContainer className={className}>
            <AutoDeliveryDcxWidgetHeader />
            <AutoDeliveryDcxWidgetContainer.ContentContainer className='md:p-0'>
                <div className='flex flex-col gap-4 rounded-xl bg-primary-dark-5 p-4 md:bg-romance md:px-6 md:py-8'>
                    <div className='flex flex-col gap-4'>
                        <AutoDeliveryDcxStatusBadge status='active' />
                        <AutoDeliveryDcxOrderFrequency
                            frequency={frequency}
                            minDeliveryDaysCount={minDeliveryDaysCount}
                            maxDeliveryDaysCount={maxDeliveryDaysCount}
                        />
                    </div>
                    <AutoDeliveryDcxActiveInfoBox
                        details={data}
                        source={AUTO_DELIVERY_INFO_BOX_SOURCES.DASHBOARD}
                        className='border-t border-solid border-mischka p-0 pt-4 md:border-none md:p-4'
                    />
                </div>
            </AutoDeliveryDcxWidgetContainer.ContentContainer>
        </AutoDeliveryDcxWidgetContainer>
    );
};

export default AutoDeliveryDcxStatusActiveNoOrder;
